import firebase from 'firebase'
export default {
  data () {
    return {
      name: '',
      date: null,
      place: '',
      type: '',
      km: 0,
      den: 0,
      part: 0
    }
  },
  methods: {
    addTrip () {
      // Get user id
      const userId = firebase.auth().currentUser.uid
      console.log(userId)
      const trip = {
        userId: userId,
        name: this.name,
        date: this.date,
        time: this.time,
        place: this.place,
        type: this.type,
        km: this.km,
        den: this.den,
        part: this.part,
        riders: []
      }
      this.$store.dispatch('addTrip', trip)
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/Ovr/propose/propose.js